import React from 'react';
import { FadeIn } from './FadeIn';
import { Shield } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-primary-dark text-text-dark pt-24 pb-20 md:pt-32 md:pb-28 overflow-hidden" data-id="element-84">
      {/* Background subtle elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-10" data-id="element-85">
        <div className="absolute top-[-10%] right-[-5%] w-[50%] h-[50%] rounded-full bg-accent blur-[120px]" data-id="element-86" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[40%] h-[40%] rounded-full bg-secondary-dark blur-[100px]" data-id="element-87" />
      </div>

      <div className="container mx-auto px-6 relative z-10 max-w-6xl" data-id="element-88">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-89">
          <div className="flex-1 text-center lg:text-left" data-id="element-90">
            <FadeIn delay={0.1} data-id="element-91">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-accent/30 bg-accent/10 text-accent text-sm font-medium mb-8" data-id="element-92">
                <Shield size={16} data-id="element-93" />
                <span data-id="element-94">Sistema de Blindaje Laboral</span>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-95">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-black leading-tight mb-6" data-id="element-96">
                Recuperá tu domingo:{' '}
                <span className="text-accent block mt-2" data-id="element-97">
                  El sistema de blindaje para que el estrés laboral deje de
                  arruinarte la vida.
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-98">
              <h2 className="text-xl md:text-2xl text-text-muted font-sans font-normal leading-relaxed mb-10 max-w-2xl mx-auto lg:mx-0" data-id="element-99">
                No necesitás renunciar mañana, necesitás que el caos de tu
                oficina deje de entrar en tu cabeza.
              </h2>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-100">
              <a href="#comprar" className="inline-block bg-accent hover:bg-accent/90 text-primary-dark font-bold text-lg px-8 py-4 rounded-md transition-all duration-300 transform hover:-translate-y-1 shadow-[0_4px_20px_rgba(201,149,62,0.3)]" data-id="element-101">
                Quiero mi paz mental de vuelta
              </a>
            </FadeIn>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none" data-id="element-102">
            <FadeIn delay={0.5} direction="left" data-id="element-103">
              <div className="relative rounded-xl overflow-hidden shadow-2xl border border-secondary-dark bg-secondary-dark/50 p-2" data-id="element-104">
                <div className="absolute inset-0 bg-gradient-to-tr from-accent/20 to-transparent opacity-30" data-id="element-105"></div>
                <img src="https://cdn.magicpatterns.com/uploads/uEU6n9dmGwn6rKKUeL3jXE/Premium_digital_eBook_202604071813.png" alt="Trabajo Bajo Control - Guía en iPad" className="w-full h-auto rounded-lg relative z-10" data-id="element-106" />
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}